import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "C:/nexus/data-gh/guide/src/components/layout/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Divider = makeShortcode("Divider");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Install Node`}</h1>
    <p>{`Node is server side Javascript, which we will use to develop our charts. Download node `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/"
      }}>{`here`}</a>{`. `}</p>
    <h1>{`Install Git`}</h1>
    <p>{`Test if you already have git installed by running the following command in your terminal.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`git --version
`}</code></pre>
    <p>{`This should print a single line listing which version you have. If you get an error message, we need to install git. Checkout `}<a parentName="p" {...{
        "href": "https://git-scm.com/book/en/v2/Getting-Started-Installing-Git"
      }}>{`this`}</a>{` installation guide for help.`}</p>
    <h1>{`Make a Github Account`}</h1>
    <p>{`If you don't have one already, create an account for `}<a parentName="p" {...{
        "href": "https://github.com/"
      }}>{`Github`}</a>{`. Once you get your username, send it to Alex on Slack to add you to the Data Section's organization.`}</p>
    <h1>{`Install VSCode`}</h1>
    <p>{`VSCode is an IDE that we'll use for development. Install it `}<a parentName="p" {...{
        "href": "https://code.visualstudio.com/download"
      }}>{`here`}</a>{`.`}</p>
    <h1>{`Install VSCode extensions`}</h1>
    <h3>{`Live Server`}</h3>
    <p>{`Open up your extensions by clicking on the icon with 4 blocks, 1 of which is removed from the other 3 on the left side bar. Alternatively, go to File -> Preferences -> Extensions.`}</p>
    <p>{`Type in 'live server' and install the first extension that shows up.`}</p>
    <h3>{`Prettier ESLint`}</h3>
    <p>{`Go to extensions again and this time type in 'Prettier ESLint'. Install the second option, 'Prettier ESLint', currently it has over 300,000 downloads.`}</p>
    <Divider mdxType="Divider" />
    <p>{`The following set of instructions will need to be done for every new project you work on.`}</p>
    <h1>{`Setting up a project`}</h1>
    <p>{`Create a new folder somewhere on your computer where you want to store the files. Open up VSCode and open the folder you just created. `}</p>
    <p>{`Open up a terminal (Terminal -> New Terminal) run the following commands, replacing `}<inlineCode parentName="p">{`REPONAME`}</inlineCode>{` with the repository's name and `}<inlineCode parentName="p">{`YOURNAME`}</inlineCode>{` with your first name.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`git init
git remote add origin https://github.com/dailynexusdata/REPONAME.git
git pull origin main
git branch -M YOURNAME
`}</code></pre>
    <p>{`Then when you've made changes, you can run the following lines to push your changes to the repo.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`git add *
git commit -m "short message describing what you did"
git push origin YOURNAME
`}</code></pre>
    <h1>{`Installing Dependencies`}</h1>
    <p>{`Open a terminal and locate your package.json file. Typically, this will be in the current directory, if not, `}<inlineCode parentName="p">{`cd`}</inlineCode>{` in to the correct directory. Then run `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` to install of the the dependencies. `}</p>
    <h1>{`Developer Menu`}</h1>
    <p>{`When we develop code, we're going to be testing it in your web browser. Often, we'll want to print out values when developing our code and this output will be put in your browser's console. Make sure you can open the develop tools in your browser.`}</p>
    <p>{`In Chrome, open up a website and right click, you should see an option 'Inspect' which brings up a side or bottom bar which tabs such as `}<inlineCode parentName="p">{`Elements`}</inlineCode>{` to show the structure of the website and `}<inlineCode parentName="p">{`Console`}</inlineCode>{` which shows code output.`}</p>
    <p>{`On Safari, you'll have to enable a setting to see this. Check out instructions `}<a parentName="p" {...{
        "href": "https://support.apple.com/en-ie/guide/safari/sfri20948/mac"
      }}>{`here`}</a>{`.`}</p>
    <Divider mdxType="Divider" />
    <p>{`The following set of instructions will need to be done every time you go to work on a project.`}</p>
    <h1>{`Starting Development`}</h1>
    <h3>{`Starting Webpack`}</h3>
    <p>{`Inside of the directory with your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, run `}<inlineCode parentName="p">{`npm start`}</inlineCode>{` which will watch for changes when you save your code and bundle your code.`}</p>
    <h3>{`Starting Live Server`}</h3>
    <p>{`On the bottom bar of VSCode, you may see `}<inlineCode parentName="p">{`Go Live`}</inlineCode>{`, which when you press will open up a page on your web browser so you can see the output of your code. `}</p>
    <p>{`If you don't see this button, go to View -> Command Palette and select 'Live Server: Open With Live Server'.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      